module.exports = __webpack_public_path__ + "static/media/dot.152e06da.png";